<template>
  <div class="w-full h-full absolute bg-black/50 text-center md:py-4 z-[150]">
    <div class="bg-white md:rounded-lg inline-block w-full max-w-2xl relative p-6 text-left max-h-full overflow-auto">
      <font-awesome-icon icon="xmark" class="text-3xl text-primary cursor-pointer float-right m-3" @click="$emit('close')" />
      <h2 class="text-2xl font-bold mb-6">Sondertage</h2>

      <div v-if="loading" class="text-center py-8 text-gray-500">Lade...</div>

      <div v-else-if="sondertage.length === 0" class="text-center py-8 text-gray-500">Keine Sondertage verfügbar.</div>

      <div v-for="st in sondertage" :key="st.id" class="mb-6 border rounded-lg p-4 shadow-sm">
        <div class="font-semibold text-lg">{{ st.label }}</div>
        <div class="text-sm text-gray-500 mb-3">
          {{ formatDate(st.startDate) }}{{ st.endDate && st.endDate !== st.startDate ? ' – ' + formatDate(st.endDate) : '' }}
        </div>

        <div v-for="ans in st.answers" :key="ans.contractId" class="flex items-center gap-4 py-2 border-t">
          <span class="flex-1 font-medium text-base">{{ ans.childName }}</span>
          <template v-if="st.editable">
            <label class="flex items-center gap-2 cursor-pointer px-3 py-1 rounded hover:bg-gray-50 border text-sm" :class="{ 'bg-green-50 border-green-300': ans.selectedAnswer === 'presence' }">
              <input type="radio" :name="`st_${st.id}_${ans.contractId}`" value="presence" :checked="ans.selectedAnswer === 'presence'" @change="ans.selectedAnswer = 'presence'" />
              <span>Anwesend</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer px-3 py-1 rounded hover:bg-gray-50 border text-sm" :class="{ 'bg-red-50 border-red-300': ans.selectedAnswer === 'exception' }">
              <input type="radio" :name="`st_${st.id}_${ans.contractId}`" value="exception" :checked="ans.selectedAnswer === 'exception'" @change="ans.selectedAnswer = 'exception'" />
              <span>Abwesend</span>
            </label>
          </template>
          <span v-else class="text-sm text-gray-400 italic">
            {{ ans.selectedAnswer === 'presence' ? 'Anwesend' : ans.selectedAnswer === 'exception' ? 'Abwesend' : '–' }}
            (nicht mehr änderbar)
          </span>
        </div>
      </div>

      <div class="w-full text-center mt-4">
        <button class="green" @click="save" :disabled="saving">{{ saving ? 'Speichert...' : 'Speichern' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/API"

export default {
  name: "SondertagePopup",
  emits: ["toast", "close"],
  props: {
    projectId: { type: [Number, String], required: true }
  },
  data() {
    return {
      loading: true,
      saving: false,
      sondertage: []
    }
  },
  methods: {
    formatDate(d) {
      if (!d) return ''
      const [y, m, day] = d.split('-')
      return `${day}.${m}.${y}`
    },
    save() {
      this.saving = true
      const answers = []
      this.sondertage.forEach(st => {
        if (!st.editable) return
        st.answers.forEach(ans => {
          if (ans.selectedAnswer) {
            answers.push({ sondertag_id: st.id, contract_id: ans.contractId, answer: ans.selectedAnswer })
          }
        })
      })
      API.submitSondertageAnswers(this.projectId, answers, (r, status) => {
        this.saving = false
        if (status === 200) {
          this.$emit('toast', 'Angaben gespeichert!')
          this.$emit('close')
        } else {
          this.$emit('toast', 'Fehler beim Speichern', 'error')
        }
      })
    }
  },
  mounted() {
    API.getSondertageForProject(this.projectId, (data, status) => {
      this.loading = false
      if (status === 200 && data.sondertage) {
        this.sondertage = data.sondertage.map(st => ({
          ...st,
          answers: st.answers.map(a => ({
            ...a,
            selectedAnswer: a.selectedAnswer || (st.default === 'anwesend' ? 'presence' : 'exception')
          }))
        }))
      }
    })
  }
}
</script>
